import React from 'react';
import configs from '../../../redux/chart-iq/chart/config';
import { MenuSelect } from './';

function getOptionLabel(layout: any) {
	let text = '';
	let periodicity = layout.periodicity;
	let interval = layout.interval;
	let timeUnit = layout.timeUnit;
	if (Number.isNaN(Number(interval))) {
		timeUnit = interval;
		interval = 1;
	}
	periodicity *= interval;
	text = periodicity;
	if (timeUnit === 'day') {
		text += 'D';
	} else if (timeUnit === 'week') {
		text += 'W';
	} else if (timeUnit === 'month') {
		text += 'M';
	} else if (timeUnit === 'tick') {
		text += 'T';
	} else if (timeUnit === 'second') {
		text += 's';
	} else if (timeUnit === 'millisecond') {
		text += 'ms';
	} else if (timeUnit === 'hour') {
		text += 'h';
	} else if (periodicity >= 60 && periodicity % 15 === 0) {
		text = periodicity / 60 + 'H';
	} else {
		text += 'm';
	}
	return (text);
}

interface IPeriodicityProps {
	ciq: any
	setPeriodicityWithLoader: (ciq: any, newPeriodicity: any) => void
}

export const Periodicity: React.FunctionComponent<IPeriodicityProps> = ({ ciq, setPeriodicityWithLoader }) => {
	if (!ciq) {
		return <div />;
	}

	const label = getOptionLabel(ciq.layout);

	return (
		<MenuSelect
			options={configs.periodicity.options}
			keyName="period"
			name="label"
			needsCiq={true}
			ciq={ciq}
			handleOptionSelect={setPeriodicityWithLoader}
			menuId="periodicitySelect"
			title={label}
		/>
	);
};